/* globals I18n */
import React from "react";

/**
 * Displays promotions that a store has opted-in to
 * NOTE: Promo vs Promos? best way to handle this?
 */
const Promo = ({ promos }) => {
  const promotions = promos !== null ? promos.map(promo =>
    <img className="w-8 mt-4 h-12 overflow-hidden" src={promo.url} alt={promo.name} key={promo.name}/>
  ) : null

  return (
    <div className="flex gap-2">
      {promotions}
    </div>
  );
};

export default Promo;
